/* eslint-disable */

import posthog from 'posthog-js';

import { PostHogProvider } from 'posthog-js/react';

const onClientEntry = () => {
    window.__DEV__ = true;
};

const transitionDelay = 500;

const posthogOptions = {
    api_host: process.env.GATSBY_PUBLIC_POSTHOG_API_HOST,
    person_profiles: 'always',
};

if (typeof window !== 'undefined') {
    posthog.init(process.env.GATSBY_PUBLIC_POSTHOG_KEY, posthogOptions);
}

const wrapRootElement = ({ element }) => {
    return (
        <PostHogProvider apiKey={process.env.GATSBY_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
            {element}
        </PostHogProvider>
    );
};

const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    if (location.action === 'PUSH') {
        window.setTimeout(() => window.scrollTo(0, 0), transitionDelay);
    } else {
        const savedPosition = getSavedScrollPosition(location);
        window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), transitionDelay);
    }
    return false;
};

export { onClientEntry, shouldUpdateScroll, wrapRootElement };
